const SearchIcon = ({ color = "#616161" }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="search-icon"
  >
    <path
      d="M8.24524 14.255H9.03524L9.31524 13.985C8.33524 12.845 7.74524 11.365 7.74524 9.755C7.74524 6.165 10.6552 3.255 14.2452 3.255C17.8352 3.255 20.7452 6.165 20.7452 9.755C20.7452 13.345 17.8352 16.255 14.2452 16.255C12.6352 16.255 11.1552 15.665 10.0152 14.685L9.74524 14.965V15.755L4.74524 20.745L3.25524 19.255L8.24524 14.255ZM14.2452 14.255C16.7352 14.255 18.7452 12.245 18.7452 9.755C18.7452 7.26501 16.7352 5.255 14.2452 5.255C11.7552 5.255 9.74524 7.26501 9.74524 9.755C9.74524 12.245 11.7552 14.255 14.2452 14.255Z"
      fill={color}
    />
  </svg>
)

export default SearchIcon
